import { FlatbondApiBase } from './base';

export class FlatbondGuarantorApi extends FlatbondApiBase {
  list(flatbondId) {
    return super.get(`${flatbondId}/guarantor`, 'Failed to list guarantors');
  }
}
